import { ALERT_SERVICE } from '../service_urls';
import { withPrefixNoArgs } from '../utils';

const withNoArgs = withPrefixNoArgs(ALERT_SERVICE);

export const clientsApis = {
  sendNotification: withNoArgs(`/clients/notify`),
};
